import axios from "axios";
import { SYSTEM_ERROR } from "../../config/CONSTANTS";
import { DASHBOARD_URL, SALE_ORDER_URL } from "../../CONSTANTS";
import Cookies from "universal-cookie";



const headersdata = {
    'content-type': 'application/json',
    'Accept': 'application/json',
    get Authorization() {
        const cook = new Cookies().get('loginData1');
        const urlParams = new URLSearchParams(window.location.search);
        const authToken = urlParams.get("at");
        return cook !== undefined ? cook.accessToken : authToken ? authToken : '';
    }
}


export const PalleteOccupacyDashBoard = () => {
    return new Promise((resolve, reject) => {
        try {
            axios.get(DASHBOARD_URL + "getPalletOccupancyList", { headers: headersdata }).then((res) => {
                resolve(res.data)
            })
                .catch((err) => {
                    reject("Error in getItemList axios!", err);
                })

        } catch (error) {
            reject(SYSTEM_ERROR);
        }
    })
}
export const getLastMonthSalesReport = () => {
    return new Promise((resolve, reject) => {
        try {
            axios.post(SALE_ORDER_URL() + "getLastMonthTotalSalesOrder", {}, { headers: headersdata }).then((res) => {
                resolve(res.data)
            })

        } catch (error) {
            reject(SYSTEM_ERROR);
        }
    })
}